// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

import React from 'react';
import { Alert, uniqueId } from '@op/opds.opux';
import message from '../messages';

interface ServiceHasNoAdminErrorTileProps {
    errors: string[];
}

const ServiceHasNoAdminErrorTile: React.FC<ServiceHasNoAdminErrorTileProps> = ({ errors }) => {
    if (errors && errors.length === 0) return null;
    return (
        <Alert type="critical" title={message('noAdminSelectedModalMessage')} data-testid="noAdminAlert">
            <ol>
                {errors.map((item) => (
                    <li key={uniqueId()} data-testid="noAdminAlertList">
                        {message(item)}
                    </li>
                ))}
            </ol>
        </Alert>
    );
};

export default ServiceHasNoAdminErrorTile;
